import React, { useState } from 'react';
import { BellRing, Mail, MessageSquare, Phone, Plus, Users } from 'lucide-react';
import { Button } from '../../ui/Button';
import { Select } from '../../ui/Select';
import { Textarea } from '../../ui/Textarea';
import { practiceHistoryKinds } from '../../../data/practiceOptions';
import { formatDateTime, newId } from '../../../utils/practices';
import { PracticeHistoryEntry, PracticeHistoryKind } from '../../../types/practice';
interface PracticeHistoryProps {
  history: PracticeHistoryEntry[];
  // Omit to render the history read-only
  onAdd?: (entry: PracticeHistoryEntry) => void;
}
const kindIcon = {
  telefono: Phone,
  email: Mail,
  messaggio: MessageSquare,
  sollecito: BellRing,
  incontro: Users
};
export function PracticeHistory({
  history,
  onAdd
}: PracticeHistoryProps) {
  const [isAdding, setIsAdding] = useState(false);
  const [kind, setKind] = useState<PracticeHistoryKind>('telefono');
  const [notes, setNotes] = useState('');
  const sorted = [...history].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  const save = () => {
    if (!onAdd) return;
    // Date and time are recorded automatically on save
    onAdd({
      id: newId('h'),
      kind,
      notes: notes.trim(),
      createdAt: new Date().toISOString()
    });
    setNotes('');
    setKind('telefono');
    setIsAdding(false);
  };
  return <div data-id="element-1596" data-mp="ob8ww2fagpwf">
      {onAdd && <div className="flex justify-end -mt-1 mb-4" data-id="element-1597" data-mp="oa7bp54k6n0z">
          {!isAdding && <Button type="button" size="sm" variant="flat" color="secondary" startContent={<Plus className="h-4 w-4" data-id="element-1599" data-mp="xcqb1f94yhih" />} onClick={() => setIsAdding(true)} data-id="element-1598" data-mp="scaz8s4i5i2m">
              Aggiungi azione
            </Button>}
        </div>}

      {isAdding && <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-4 mb-5 space-y-4" data-id="element-1600" data-mp="2z5ela8k7657r">
          <Select label="Tipo di azione" value={kind} onChange={e => setKind(e.target.value as PracticeHistoryKind)} options={practiceHistoryKinds.map(k => ({
        value: k.kind,
        label: k.label
      }))} data-id="element-1601" data-mp="344he8umwkkzd" />
          <Textarea label="Note" rows={3} value={notes} onChange={e => setNotes(e.target.value)} description="Data e ora vengono registrate automaticamente al salvataggio" data-id="element-1602" data-mp="35xs6z943y2mr" />
          <div className="flex justify-end gap-2" data-id="element-1603" data-mp="3azhiepv8sibd">
            <Button type="button" size="sm" variant="flat" color="default" onClick={() => {
          setIsAdding(false);
          setNotes('');
        }} data-id="element-1604" data-mp="3awvf52fdwoyy">
              Annulla
            </Button>
            <Button type="button" size="sm" onClick={save} data-id="element-1605" data-mp="2h1xuld8b9gu">
              Salva azione
            </Button>
          </div>
        </div>}

      {sorted.length === 0 ? <p className="text-sm text-slate-500" data-id="element-1606" data-mp="h6d26f2zlo1r">Nessuna azione registrata.</p> : <ol className="space-y-4" data-id="element-1607" data-mp="l65dv0nogabc">
          {sorted.map(entry => {
        const Icon = kindIcon[entry.kind];
        const label = practiceHistoryKinds.find(k => k.kind === entry.kind)?.label || entry.kind;
        return <li key={entry.id} className="flex gap-3" data-id="element-1608" data-mp="3tmqdhquf5r1s">
                <span className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0" data-id="element-1609" data-mp="3tl5jq3fxic4z">
                  <Icon className="h-4 w-4 text-slate-500" data-id="element-1610" data-mp="3kmk5ullejlaj" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-1611" data-mp="3kkh79d66oju7">
                  <p className="text-sm font-medium text-slate-800" data-id="element-1612" data-mp="3pkvhn1v9c5ve">
                    {label}
                    <span className="ml-2 text-xs font-normal text-slate-400 tabular-nums" data-id="element-1613" data-mp="3ao4echigqa0i">
                      {formatDateTime(entry.createdAt)}
                    </span>
                  </p>
                  {entry.notes && <p className="text-sm text-slate-600 mt-0.5 whitespace-pre-line" data-id="element-1614" data-mp="ms7c3jcdxeya">
                      {entry.notes}
                    </p>}
                </div>
              </li>;
      })}
        </ol>}
    </div>;
}